export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const whatsappUrl = (prefill) =>
  `https://wa.me/18576152967?text=${encodeURIComponent(prefill || "Hi ClearRoute!")}`;

// Placeholder until the Google Business Profile Place ID exists — opens Maps search for the shop.
export const REVIEW_URL =
  "https://www.google.com/maps/search/?api=1&query=ClearRoute+Auto+Glass+98+Foster+St+Peabody+MA";

export const REVIEW_LABEL = {
  en: "Review us on Google",
  pt: "Avalie-nos no Google",
  es: "Déjanos una reseña",
};

export const CARRIERS = [
  "Geico", "Progressive", "State Farm", "MAPFRE", "Liberty Mutual", "Arbella",
  "Safety Insurance", "Plymouth Rock", "Travelers", "Allstate", "USAA",
  "Amica", "The Hartford", "Nationwide", "Hanover", "Quincy Mutual",
  "Vermont Mutual", "National General", "Farmers", "MetLife", "American Family",
];

export const INSURANCE_STRINGS = {
  en: { placeholder: "Insurance company (optional)", notSure: "Not sure", none: "No insurance / paying myself" },
  pt: { placeholder: "Seguradora (opcional)", notSure: "Não sei", none: "Sem seguro / vou pagar direto" },
  es: { placeholder: "Aseguradora (opcional)", notSure: "No estoy seguro", none: "Sin seguro / pago yo" },
};

export const TRACK_STRINGS = {
  en: {
    title: "Track your quote", sub: "Enter the code we showed you after sending your request.",
    placeholder: "Code (e.g. a1b2c3d4)", button: "Track", notFound: "Code not found — check and try again.",
    statuses: { new: "Request received", contacted: "We've contacted you", scheduled: "Appointment scheduled", completed: "Job completed" },
    slotLabel: "Appointment", serviceLabel: "Service", codeLabel: "Your tracking code",
  },
  pt: {
    title: "Acompanhe seu orçamento", sub: "Digite o código que apareceu quando você enviou o pedido.",
    placeholder: "Código (ex: a1b2c3d4)", button: "Acompanhar", notFound: "Código não encontrado — confira e tente de novo.",
    statuses: { new: "Pedido recebido", contacted: "Entramos em contato", scheduled: "Serviço agendado", completed: "Trabalho concluído" },
    slotLabel: "Agendamento", serviceLabel: "Serviço", codeLabel: "Seu código de acompanhamento",
  },
  es: {
    title: "Rastrea tu cotización", sub: "Ingresa el código que apareció al enviar tu solicitud.",
    placeholder: "Código (ej: a1b2c3d4)", button: "Rastrear", notFound: "Código no encontrado — revísalo e intenta de nuevo.",
    statuses: { new: "Solicitud recibida", contacted: "Te contactamos", scheduled: "Cita agendada", completed: "Trabajo completado" },
    slotLabel: "Cita", serviceLabel: "Servicio", codeLabel: "Tu código de seguimiento",
  },
};

export const FOOTER_LINKS = {
  en: { blog: "Blog", track: "Track your quote" },
  pt: { blog: "Blog", track: "Acompanhar orçamento" },
  es: { blog: "Blog", track: "Rastrear cotización" },
};

export const SLOT_STRINGS = {
  en: { label: "Preferred date & time", hint: "Optional — we confirm by text. Same-day? Call us.", pickTime: "Pick a time" },
  pt: { label: "Data e horário preferidos", hint: "Opcional — confirmamos por mensagem. Hoje mesmo? Ligue pra gente.", pickTime: "Escolha o horário" },
  es: { label: "Fecha y hora preferidas", hint: "Opcional — confirmamos por mensaje. ¿Hoy mismo? Llámanos.", pickTime: "Elige la hora" },
};
